<tidy-card>
  <div class="header-row">
    <div>
      <img [src]="pro?.imageUrl" class="background-image" />
    </div>
    <div class="header-content-row">
      <tidy-text [header]="pro?.businessName" />
      @if (rating >= 0) {
        <div class="rating-row">
          <div>
            @for (star of stars; track star; let i = $index) {
              <tidy-image
                [src]="i < rating ? 'assets/svg/star-tidy-green.svg' : 'assets/svg/star-grey.svg'" />
            }
          </div>
          @if (pro?.rating && pro?.numReviews) {
            <tidy-text
              [smallBody]="pro?.rating?.toFixed(2) + ' - ' + pro?.numReviews"
              [translate]="false"
              class="reviews-text" />
            <tidy-text
              [smallBody]="'reviews'"
              class="reviews-text" />
          }
        </div>
      }
      @if (pills?.length > 0) {
        <div class="pills-row">
          @for (pill of pills; track pill) {
            <div [class]="pill?.class">
              <tidy-text [smallBody]="pill?.label" />
            </div>
          }
        </div>
      }
    </div>
  </div>
  <div>
    @if (pro?.businessLocation) {
      <div class="pro-info-row">
        <tidy-image src="assets/svg/location-outline.svg" />
        <tidy-text [smallBody]="pro?.businessLocation" />
      </div>
    }
    @if (pro?.numHires) {
      <div class="pro-info-row">
        <tidy-image src="assets/svg/trophy-outline.svg" />
        <tidy-text [smallBody]="'Hired'" />
        <tidy-text [smallBody]="pro?.numHires" [translate]="false" />
        <tidy-text [smallBody]="'times'" />
      </div>
    }
    @if (pro?.yearsInBusiness) {
      <div class="pro-info-row">
        <tidy-image src="assets/svg/briefcase-outline.svg" />
        <tidy-text [smallBody]="pro?.yearsInBusiness" [translate]="false" />
        <tidy-text [smallBody]="'years in business'" />
      </div>
    }
  </div>
  <div>
    @if (pro?.featuredReview) {
      <div class="featured-review-row">
        <div>
          <tidy-image src="assets/icon/left-quote.png" class="left-quote" />
        </div>
        <div>
          <tidy-text
            [smallBody]="!isReviewExpanded ? (pro?.featuredReview | truncate:90:true) : pro?.featuredReview" />
        </div>
        @if (pro?.featuredReview?.length > 90) {
          <div class="show-more-row" (click)="toggleReview()">
            <tidy-text [smallBody]="!isReviewExpanded ? 'Show More' : 'Show Less'" />
            <tidy-image
              src="assets/icon/arrow-green.png"
              [class]="isReviewExpanded ? 'arrow-green-icon arrow-down' : 'arrow-green-icon arrow-up'" />
          </div>
        }
      </div>
    }
  </div>
  <div>
    @if (pro?.thumbtackUrl) {
      <tidy-button
        [text]="'Select & Continue'"
        [class]="'primary thumbtack-button'"
        (click)="onClickSelectPro(pro)" />
    }
  </div>
</tidy-card>
